import React from "react";
import { Panel } from "../components/panels";

interface Props {
  secret: string
  otherFiles: server.dto.ESignFile[]
}

const OtherFilesPanel = (props: Props) => {
  return <Panel
    title={RESX.ESign.OtherFiles}
    panelClassName="s1_related-feature-panel"
    articleId={serverReference.supportArticleIds.eSignOtherFiles}
  >
    <div className="list-with-gaps line-layout">
      <div className="list-with-gaps-body">
        {props.otherFiles.map(file => {
          const url = file.openDownloadUrl.replace("{secret}", props.secret);

          return <div key={file.eSignFileId} className="">
            <div className="margin-right">
              <i className="icon-download small" />
            </div>
            <div className="grow1">
              <h4><a download href={url}>{file.name}.{file.extension}</a></h4>
            </div>
            <div style={{ whiteSpace: "nowrap" }}>
              {file.contentLengthText}
            </div>
          </div>;
        })}
      </div>
    </div>
  </Panel>;
};

export default OtherFilesPanel;